import { useQuery } from "@tanstack/react-query";
import { Switch } from "@/components/ui/switch";
import { Checkbox } from "@/components/ui/checkbox";
import { api } from "@/lib/api";

export const SuggestionPolicy = ({ universe, isOwner, patch }) => {
  const pol = universe.suggestion_policy || { allow_votes: false, delegates: [] };
  const { data: members = [] } = useQuery({ queryKey: ["members", universe.id], queryFn: () => api.get(`/universes/${universe.id}/members`).then((r) => r.data) });
  const editors = members.filter((m) => m.role === "editor");
  const set = (p, msg) => patch({ suggestion_policy: { ...pol, ...p } }, msg);
  return (
    <div className="space-y-4" data-testid="settings-suggestions">
      <p className="text-sm text-[#E8DFD1]">You always have the final say as owner.</p>
      <div className="flex items-center justify-between gap-4">
        <div><div className="text-sm text-[#F3EBDD]">Editors can vote</div><div className="text-xs text-[#A8A090]">Editors give suggestions a thumbs up or down to help you decide.</div></div>
        <Switch checked={!!pol.allow_votes} disabled={!isOwner} onCheckedChange={(v) => set({ allow_votes: v }, v ? "Voting on" : "Voting off")} data-testid="settings-suggest-votes" />
      </div>
      <div>
        <div className="text-sm text-[#F3EBDD]">Editors who can accept or reject for you</div>
        <div className="mb-2 text-xs text-[#A8A090]">They can decide on others' suggestions, never their own.</div>
        {editors.length === 0 ? <p className="text-xs italic text-[#A8A090]">No editors in this universe yet.</p> : (
          <div className="space-y-1.5">
            {editors.map((m) => (
              <label key={m.user_id} className="flex items-center gap-2 text-sm text-[#E8DFD1]">
                <Checkbox checked={pol.delegates.includes(m.user_id)} disabled={!isOwner} data-testid={`settings-suggest-delegate-${m.user_id}`}
                  onCheckedChange={(v) => set({ delegates: v ? [...pol.delegates, m.user_id] : pol.delegates.filter((x) => x !== m.user_id) }, "Permissions updated")} />
                {m.name || m.email}<span className="text-xs text-[#A8A090]">{m.email}</span>
              </label>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
